import '../public';

import { back2Top } from '../components/back2top';
import { initBusinessCards } from '../components/businessCard';
import { initFormMakerDropzones } from '../components/formmaker-dropzone';
import { processPageContent } from '../components/pageContent';
import { initPhotoSwipeSingleImage } from '../components/photoSwipeGallery';
// Primární navigace: site-navbar (lišta) + site-navigation (menu)
import { initSiteNavbars } from '../components/site-navbar';
import { initSiteNavigations } from '../components/site-navigation';
import { addClass, hasClass } from '../helpers/generic';
import { initBootstrapModalFocusRelease, modalBackdropResize } from '../helpers/modals';
import { scrollableResponsiveTables, scrollToHash } from '../helpers/scroll';

// Initial onLoad settings for the website page
const onPageLoaded = (): void => {
    const html = document.getElementsByTagName('html')[0];

    // Bootstrap modal: uvolnění fokusu před aria-hidden (Chromium console warning) — viz helper
    initBootstrapModalFocusRelease();

    // =========================================================================
    // Primární navigace = site-navbar (lišta) + site-navigation (menu ve slotech)
    // =========================================================================
    initSiteNavbars();
    initSiteNavigations();
    window.__WEBSITE__.AppSettings.primaryNavigation = document.getElementById('primary-navigation');

    const qrcPageLink = document.getElementsByClassName('footer-links__link--qrc-page')[0];
    if (qrcPageLink) {
        initPhotoSwipeSingleImage(qrcPageLink as HTMLLinkElement);
    }

    // QR na vizitce → SVG v lightboxu (PhotoSwipe); chybí-li odkaz v HTML, doplní se
    const businessCardQrBlocks = document.querySelectorAll('.business-card__qr');
    for (const qrBlock of Array.from(businessCardQrBlocks)) {
        let qrLink = qrBlock.querySelector('.business-card__qr-link') as HTMLAnchorElement | null;
        if (!qrLink) {
            const qrImg = qrBlock.querySelector('img') as HTMLImageElement | null;
            if (!qrImg?.src) {
                continue;
            }
            qrLink = document.createElement('a');
            qrLink.className = 'business-card__qr-link';
            qrLink.href = qrImg.currentSrc || qrImg.src;
            qrLink.title = qrImg.alt || 'QR kód';
            qrImg.replaceWith(qrLink);
            qrLink.appendChild(qrImg);
        }
        qrLink.setAttribute('data-size', '600x600');
        qrLink.removeAttribute('target');
        qrLink.removeAttribute('download');
        initPhotoSwipeSingleImage(qrLink);
    }

    const linksToImages = document.querySelectorAll(
        [
            "#page-content a[href$='.jpg']:has(img)",
            "#page-content a[href$='.png']:has(img)",
            "#page-content a[href$='.gif']:has(img)",
            "#page-content a[href$='.JPG']:has(img)",
            "#page-content a[href$='.PNG']:has(img)",
            "#page-content a[href$='.GIF']:has(img)",
            "#page-content a[href*='image.php?img=']:has(img)",
        ].join(','),
    );
    for (const linkEl of Array.from(linksToImages)) {
        const linkToImage: HTMLLinkElement = linkEl as HTMLLinkElement;
        // to prevent attaching double-events
        // (dela to pak problem pri zavirani, .pswp--open se neodstrani):
        if (
            !hasClass(linkToImage, 'related-files__item-link') &&
            !hasClass(linkToImage, 'photo-gallery__item-link')
        ) {
            initPhotoSwipeSingleImage(linkToImage);
        }
    }

    // FormMaker — drag & drop / okamžitý upload příloh (brzy, ať nespadne na chybě níže)
    initFormMakerDropzones();

    // "obliznuti" obsahu specifickymi funkcionalitami
    processPageContent(document.body);

    // vizitka — Uložit kontakt (vCard z textu na kartě; tlačítko doplní i u staršího HTML)
    initBusinessCards(document);

    // back2top button
    back2Top(); // first init

    //manageMenuItems(); ...executed as callback in stickyNavigationToggle
    scrollableResponsiveTables();

    // scroll to url hash (if present)
    setTimeout(function () {
        scrollToHash();
    }, 500); // je potreba pockat, az se upravi menu

    addClass(html, 'page-loaded');
};

// scroll / resize: primární navigace si listenery registruje sama (site-navbar / site-navigation)
const onWindowScroll = (): void => {
    back2Top(); // back2top button check
};

const onWindowResize = (e: UIEvent): void => {
    modalBackdropResize();
    scrollableResponsiveTables();
};

window.addEventListener('resize', onWindowResize);

document.addEventListener('scroll', onWindowScroll, false);

document.addEventListener('DOMContentLoaded', onPageLoaded);

// add simple support for lazy-load of background images:
document.addEventListener('lazybeforeunveil', function (e: Event) {
    const bg = (e.target as HTMLElement).getAttribute('data-bg');
    if (bg) {
        (e.target as HTMLElement).style.backgroundImage = 'url(' + bg + ')';
    }
});
